import Vue from "vue";
import {
  GetterTree,
  ActionTree,
  MutationTree
} from "vuex";
import { CashRegisterModel } from "@/shared/models/cashRegister";
import { ListModel } from "@/shared/models/listModel";

export class CashRegisterStorage {
  tenantId = 0;
  userId = 0;
  cashRegisterId = 0;
}

export class CashRegisterState {
  activeCashRegister?: CashRegisterModel = {
    id: 0,
    name: "",
    businessUnitId: 0,
    currencyId: 0,
    status: false,
    businessUnitStatus: true,
    isLinkedToFiscalizationService: false,
    shouldBeLinkedToFiscalizationService: false
  };

  allCashRegisters?: CashRegisterModel[] = [];

  availableCashRegisters?: CashRegisterModel[] = [];

  storedData?: CashRegisterStorage[] = [];
}

const storageKey = "pms.cr";

const initialState = new CashRegisterState();

const state = { ...initialState };

function saveState() {
  const stringified = JSON.stringify(state.storedData);
  if (state.storedData && localStorage.getItem(storageKey) != stringified) {
    localStorage.setItem(storageKey, stringified);
  }
}

const getters: GetterTree<CashRegisterState, any> = {
  activeCashRegister: (state) => state.activeCashRegister,
  availableCashRegisters: (state) => state.availableCashRegisters,
  allCashRegisters: (state) => state.allCashRegisters,
  cashRegisterStorage: (state) => state.storedData,
};

const actions: ActionTree<CashRegisterState, any> = {
  refreshCashRegisters({ commit }) {
    return Vue.axios
      .get<ListModel<CashRegisterModel>>(
        `/cashRegisters`
      )
      .then(
        ({ data }) =>
          (commit("setAvailableCashRegisters", data.result.filter(x => x.status)),
          (commit("setAllCashRegisters", data.result))),
      );
  },
  setActiveCashRegister({commit}, payload ) {
    commit("setActiveCashRegister", payload);
  },
  removeActiveCashRegister({commit}) {
    commit("removeActiveCashRegister");
  },
  async setCashRegisterFromStorage({dispatch} ,payload) {
    const stored = localStorage.getItem(storageKey);
    if((state.availableCashRegisters?.length ?? 0) === 0) {
      await dispatch("refreshCashRegisters", payload.tenantId);
    }
    if (stored) {
      try {
        const parsed = JSON.parse(stored) as CashRegisterStorage[];
        state.storedData = parsed;
        const id = parsed.find(x => x.userId == payload.userId && x.tenantId == payload.tenantId)?.cashRegisterId;
        state.activeCashRegister = state.availableCashRegisters?.find(x => x.id == id);
      } catch {
        /* empty */
      }
    }
    else {
      state.storedData = [];
      state.activeCashRegister = undefined;
    }
  },
  clearCashRegisters({commit}) {
    commit("clearCashRegisters");
  },
};
const mutations: MutationTree<CashRegisterState> = {
  reset: (state) => {
    Object.assign(state, initialState);
  },
  setAvailableCashRegisters: (state, value) => {
    state.availableCashRegisters = value.slice();
  },
  setAllCashRegisters: (state, value) => {
    state.allCashRegisters = value.slice();
  },
  setActiveCashRegister: (state, value) => {
    state.activeCashRegister = value.cashRegister;
    const data = {
      tenantId: value.tenantId,
      userId: value.userId,
      cashRegisterId: value.cashRegister.id,
    } as CashRegisterStorage;
    const x = state.storedData?.findIndex(x => x.userId == data.userId && x.tenantId == data.tenantId);
    if(x !== undefined && x !== -1)
    {
      state.storedData?.splice(x, 1, data);
    }
    else
    {
      state.storedData?.push(data);
    }
    saveState();
  },
  removeActiveCashRegister: (state) => {
    state.activeCashRegister = undefined;
  },
  clearCashRegisters: (state) => {
    state.availableCashRegisters = [];
  }
};

export default {
  namespaced: true,
  state: () => state,
  getters,
  actions,
  mutations,
};